<template>
  <div class="empty-container">
    <div class="empty-icon">
      <slot name="icon" v-if="$slots.icon"></slot>
    </div>
    <div class="empty-title" v-if="$slots.title || title">
      <slot name="title">{{title}}</slot>
    </div>
    <div class="empty-desc">
      <slot name="desc">{{desc}}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    title: String,
    desc: String
  }
}
</script>

<style scoped lang="less">
@w2: 75rem;
.empty-container {
  text-align: center;
  .empty-icon {
    width: 176/@w2;
    height: 176/@w2;
    margin: 0 auto 40/@w2;
    /deep/ img {
      width: 100%;
      height: 100%;
    }
  }
  .empty-title {
    font-size: 32/@w2;
    font-weight: bold;
    color: #7f7f7f;
    line-height: 46/@w2;
    margin-bottom: 7/@w2;
  }
  .empty-desc {
    font-size: 26/@w2;
    font-weight: 400;
    color: #999;
    line-height: 46/@w2;
  }
}
</style>
